import React = require("react");
import {Carousel} from "react-responsive-carousel";
import {Loader} from "../../../components/Utils/loader/Loader";
import "../settings/SettingsSection.scss";
import "./Carousel.scss";
import {Button, EmptyState, infoIcons, Tooltip} from "@vebox/etui-core";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {ROUNDED_BUTTON_STYLE} from "../../../users/UserDetails";
import {ProtectedImageDisplay} from "../../../components/ProtectedImageDisplay";

declare var AppTranslations: AppTranslations;

interface EquipmentImage {
    guid: string;
    href: string;
    label?: string;
}

interface EquipmentImagesProps {
    title: string;
    titleValue?: string;
    subtitle?: string;
    images: EquipmentImage[];
    noImagesAvailableText;
    editable: boolean;
    deletePlantImages: (photoGuid: string) => void;
    showModalUploadPlantImage: () => void,
    defaultSelectedImage: number
}

export class EquipmentImageSection extends React.Component<EquipmentImagesProps, any> {
    constructor(props) {
        super(props);

        this.showModalUploadPlantImage = this.showModalUploadPlantImage.bind(this);
        this.deletePlantImages = this.deletePlantImages.bind(this);
    }

    public shouldComponentUpdate(nextProps: Readonly<EquipmentImagesProps>,
                                 nextState: Readonly<any>, nextContext: any): boolean {
        const {images, editable, defaultSelectedImage} = this.props;

        const should = images == null
            || images.length === 0
            || images.length !== nextProps.images.length
            || editable !== nextProps.editable
            || defaultSelectedImage !== nextProps.defaultSelectedImage;

        if (!should && (nextProps.images != null && nextProps.images.length > 0)) {
            return images.find(({href}, idx) => href !== nextProps.images[idx].href) !== undefined
        }
        return true;
    }

    public render() {
        const {
            images,
            noImagesAvailableText,
            editable,
            title,
            titleValue,
            subtitle,
            defaultSelectedImage
        } = this.props;
        let content = <Loader/>;
        let carouselClass = "settings-body carousel-container";
        if (images != null) {
            if (images.length === 0) {
                carouselClass = "settings-body";
                content = (
                    <EmptyState>
                        <EmptyState.InfoIcon
                            styles={{
                                root: {
                                    color: "var(--empty-indicator-svg-stroke)"
                                }
                            }}
                            glyph={infoIcons.NoContent}
                        />
                        <EmptyState.Title color="var(--empty-indicator-title-color)">{noImagesAvailableText}</EmptyState.Title>
                        <EmptyState.SubTitle color="var(--empty-indicator-subtitle-color)"/>
                    </EmptyState>
                );
            } else {
                const imagesList = images.map(
                    (image) => (
                        <div key={""} className={"carousel-section"}>
                            <ProtectedImageDisplay src={image.href} alt={image.label} key={image.href}/>
                            {image.label && <p
                                className={"carousel-legend"}
                                style={editable ? {justifySelf: "start"} : {justifySelf: "center"}}
                            >{image.label}</p>}
                            {editable && (
                                <div className={"remove-equipment-picture"}>
                                    <Tooltip
                                        message={AppTranslations.equipmentImagesPage.deleteImage}
                                        placement={"left"}
                                    >
                                        <Button
                                            onClick={this.deletePlantImages(image.guid)}
                                            variant={"strong"}
                                            shape={"circle"}
                                            styles={{root: ROUNDED_BUTTON_STYLE}}
                                        >
                                            <span className="material-icons-outlined">delete</span>
                                        </Button>
                                    </Tooltip>
                                </div>
                            )}
                        </div>
                    ),
                );
                content = (
                    <Carousel
                        showArrows={true}
                        width={"100%"}
                        showThumbs={false}
                        swipeable={true}
                        infiniteLoop={true}
                        autoPlay={true}
                        interval={10000}
                        selectedItem={defaultSelectedImage}
                    >
                        {imagesList}
                    </Carousel>
                );
            }
        }
        return (
            <div className="settings-section">
                <div className="settings-header">
                    <div className="grid-header">
                        <p className="settings-header__label">
                            {title}
                            {titleValue != null && (
                                <React.Fragment>
                                    <span>: </span>
                                    <span className="settings-header__title">{titleValue}</span>
                                </React.Fragment>)}
                        </p>
                        {editable && (
                            <div className={"add-equipment-picture"}>
                                <Tooltip message={AppTranslations.equipmentImagesPage.addNewImage} placement={"left"}>
                                    <Button
                                        shape={"circle"}
                                        variant={"secondary"}
                                        onClick={this.showModalUploadPlantImage}
                                        styles={{root: ROUNDED_BUTTON_STYLE}}
                                    >
                                        <span className="material-icons">add_photo_alternate</span>
                                    </Button>
                                </Tooltip>
                            </div>
                        )}
                        {subtitle && <p className="settings-header__sublabel">{subtitle}</p>}
                    </div>
                </div>
                <div className={carouselClass}>
                    <div className="settings-content">
                        {content}
                    </div>
                </div>
            </div>
        );
    }

    private deletePlantImages(imageGuid: string) {
        return () => {
            this.props.deletePlantImages(imageGuid)
        }
    }

    private showModalUploadPlantImage() {
        this.props.showModalUploadPlantImage()
    }
}